/*
 * @Description:
 * @Author: fal
 * @Date: 2025-02-28 10:17:10
 * @FilePath: \web\pc.ui\src\project\router\modules\front.js
 * @LastEditTime: 2025-03-03 10:19:01
 */
export const frontRoutes = [
  // 前台登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/project/views/front/login/login'),
  },
  // 前台首页
  {
    path: '/',
    name: 'index',
    component: () => import('@/project/views/front/index/index'),
  },
  // 项管系统
  {
    path: '/front/intro',
    component: () => import('@/project/views/front/intro/intro'),
    name: 'frontintro',
  },
  // 工程招聘
  {
    path: '/front/hire',
    name: 'frontHire',
    component: () => import('@/project/views/front/hire/hire'),
  },
  // 材料设备
  {
    path: '/front/material',
    name: 'frontmaterial',
    component: () => import('@/project/views/front/material/material'),
  },
  // 工程机械
  {
    path: '/front/machine',
    name: 'frontmachine',
    component: () => import('@/project/views/front/machine/machine'),
  },
  // 业务大厅
  {
    path: '/front/business',
    name: 'frontbusiness',
    component: () => import('@/project/views/front/business/business'),
  },
  // 关于我们
  {
    path: '/front/about',
    name: 'frontAbout',
    component: () => import('@/project/views/front/about/about'),
  },
  // 操作手册
  {
    path: '/front/info/operate',
    name: 'frontOperate',
    component: () => import('@/project/views/front/info/operate'),
  },
  // 操作手册-详情
  {
    path: '/front/info/newdoc',
    name: 'frontNewdoc',
    component: () => import('@/project/views/front/info/newdoc'),
  },
  // 报价页面
  {
    path: '/front/quotationDetails',
    name: 'quotationDetails',
    component: () => import('@/project/views/front/quotation/quotationDetails'),
  },
  // 招聘信息
  {
    path: '/front/info/jobInfo',
    name: 'jobInfo',
    component: () => import('@/project/views/front/info/jobInfo'),
  },
  // 求职信息
  {
    path: '/front/info/jobHuntInfo',
    name: 'jobHuntInfo',
    component: () => import('@/project/views/front/info/jobHuntInfo'),
  },
  // 劳务供应信息
  {
    path: '/front/info/laborSupplyInfo',
    name: 'laborSupplyInfo',
    component: () => import('@/project/views/front/info/laborSupplyInfo'),
  },
  // 公司信息
  {
    path: '/front/info/companyInfo',
    name: 'companyInfo',
    component: () => import('@/project/views/front/info/companyInfo'),
  },
  // 材料/机械设备商品信息
  {
    path: '/front/info/storeInfo',
    name: 'storeInfo',
    component: () => import('@/project/views/front/info/storeInfo'),
  },
  // 材料/机械设备商品详情
  {
    path: '/front/info/storeDetails',
    name: 'storeDetails',
    component: () => import('@/project/views/front/info/storeDetails'),
  },
  // 招聘搜索页
  {
    path: '/front/hire/search',
    name: 'hireSearch',
    component: () => import('@/project/views/front/hire/search'),
  },
  // 材料搜索页
  {
    path: '/front/material/search',
    name: 'materialSearch',
    component: () => import('@/project/views/front/material/search'),
  },
  // 机械搜索页
  {
    path: '/front/machine/search',
    name: 'machineSearch',
    component: () => import('@/project/views/front/machine/search'),
  },
  // 行业咨询搜索页
  {
    path: '/front/business/search',
    name: 'businessSearch',
    component: () => import('@/project/views/front/business/search'),
  },
];
